<ifb-application-notes-sidenav [applicationId]="data.application?.id"
                               [notes]="data.application?.notes"
                               [initiator]="data.userCurrent"
                               [saveOnDemand]="true"
                               [innerSidenav]="true">

  <ifc-app-scroll-container [widgetsWithTopHeader]="true">
    <div class="layout margin flex-std"
         [@routerTransition]="'fly'">
      <ifb-panel>
        <ifb-card>
          <ifb-application-status-widget [data]="data"> </ifb-application-status-widget>
          <ng-container *ngIf="data?.application?.type === 'Renewal'; else ownersWidget">
            <ifc-simple-horizontal-list-widget title="Renewals"
                                               [listItems]="renewalsListData"
                                               [config]="{ isEditable: true }"
                                               (edit)="onEditRenewals()">
            </ifc-simple-horizontal-list-widget>
          </ng-container>
        </ifb-card>

        <ifb-card>
          <ifb-application-company-info-widget [data]="data"></ifb-application-company-info-widget>
          <ng-container *ngIf="data?.application?.type === 'Renewal'">
            <ng-container *ngTemplateOutlet="ownersWidget"></ng-container>
          </ng-container>
        </ifb-card>

        <ifb-card>
          <ifc-simple-horizontal-list-widget title="Other info"
                                             [listItems]="otherInfoListData">
          </ifc-simple-horizontal-list-widget>
          <ifb-signing-widget *ngIf="showSigningCard"
                              [signatureMethod]="data.application.signatureMethod"
                              [envelope]="envelope"
                              [switchOptions]="switchSignatureMethodOptions"
                              (switchMethod)="changeSignatureMethod($event)">
          </ifb-signing-widget>
          <ifb-business-advisor-widget [data]="advisorData"
                                       [canEditAdvisor]="canEditAdvisor"
                                       (edit)="changeAdvisor()">
          </ifb-business-advisor-widget>
        </ifb-card>

        <ng-template #ownersWidget>
          <ifb-owners-widget [owners]="data.owners"
                             [signers]="envelope?.recipients"></ifb-owners-widget>
        </ng-template>
      </ifb-panel>
    </div>
  </ifc-app-scroll-container>

</ifb-application-notes-sidenav>
